import { getDateRange } from "../../utils/common"

const dateRange = getDateRange()

const states = {
  journey_analytics_details: {
    filter_date_range: dateRange,
    filter_preset: "last7days",
    filter_journey: "all",
    filter_channel: "all",

    journeys_list: [],
    journeys_loading: false,

    funnel_data: null,
    funnel_loading: false,
    funnel_load_error: false,

    dropoff_reasons: null,
    dropoff_reasons_loading: false,
    selected_step: null,

    chart_view: 'funnel',
    flow_data: null,
    flow_loading: false,
    flow_load_error: false,
  },
}

export default states
